import React from 'react';

export const ModalContext = React.createContext({
	idCounter: 0,
	modals: [],
	dialogs: [],
	showModal: () => {},
	showError: () => {},
	showMessage: () => {},
	showDirtyStateModal: () => {},
	showTutorial: () => {},
	closeTutorial: () => {},
	closeModal: () => {},
	closeAll: () => {},
});
